<template>
  <div>
      <CCard>
      <CCardHeader>
        <CIcon name="cil-user" /><strong>User List</strong>
      </CCardHeader>
      <CCardBody>
          <div class="card-header-actions">
            <small class="text-muted"
              >
        <multiselect
                size="sm"
              :limit="2"
              :clear-on-select="false"
              :close-on-select="true"
              :multiple="false"
              :options="perPage"
              :preselect-first="false"
              :preserve-search="false"
              @input="checkPage()"
              placeholder="PerPage"
              v-model="tableperpage"
            ></multiselect></small
            ></div>
      <!-- Main table element -->
      <CDataTable
      :items="items"
      :fields="fields"
      :dark="false"
      :items-per-page="tableperpage"
      pagination
      sorter
      hover
      striped
      border
      small
      fixed
      table-filter
      light
    >
    <template #name="{item}">
        <td v-if="item.role != 'manager'">{{ item.username }}</td>
    </template>

    <template #action="{item}">
      <td v-if="item.role != 'manager'">
          <span @click="update(item)">
        <CImg v-if="item.isactive == true" src="img/logo/push.png" class="img-fluid ml-1" title="Inactive" :pressed.sync="item.status"
          style="cursor: pointer;"
          ></CImg>
        <CImg v-if="item.isactive == false" src="img/logo/play.png" class="img-fluid ml-1" title="Active" :pressed.sync="item.status"
            style="cursor: pointer;"
        ></CImg>
        </span>
         <span v-if="item.isactive == true"> Deactivate</span>
        <span v-if="item.isactive == false"> Activate</span>
          </td>
    </template>
    </CDataTable>
    </CCardBody></CCard>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import ModeratorService from './../../services/moderatorControlService'
  export default {
    components: {Multiselect},
    data() {
      return {
        email:'',
        input:{},
        show_model:false,
        tableperpage:20,
        perPage:[20,50,100],
        items: [],
        fields: [
          { key: 'name', label: 'User Name'},
          { key: 'email', label: 'Email'},
          {key: 'action',label: 'Action'}
        ],
        totalRows: 1,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        users:[],
      }
    },
    computed: {
      
    },
   async mounted() {
      if(window.localStorage.getItem('user') == 'null' || window.localStorage.getItem('user') != 'moderator') {
        alert('Please Enter User Name and Password')
          window.localStorage.setItem("user", null);
          window.localStorage.setItem("status", null);
          window.localStorage.setItem("email", null);
        this.$router.push('/pages/login')
      }
      this.email = window.localStorage.getItem('email')
      this.role = window.localStorage.getItem('role')
      if(localStorage.getItem("user_table") != null)
      this.tableperpage = parseInt(localStorage.getItem("user_table"));
      this.getUsers()
      
    },
    methods: {
      checkPage(){
          localStorage.setItem("user_table", this.tableperpage);
        },
       async getUsers(){
            let response
        try {
            response = await ModeratorService.getuser()
            this.users = response.data
            this.items = this.users
            this.totalRows = this.items.length
        } catch(e){
            console.error("Error in login")
            console.log(e)
        }
        },
     async update(data){
        let response
        try {
            if(data.isactive == true){
                data.isactive = false
            }
            else{
                data.isactive = true
            }
            let payload = {
                email : data.email,
                changeObject : {
                  isactive: data.isactive
                }
              }
          response = await ModeratorService.changestatus(payload)
          if (response.result == true) {
              Swal.fire({title: 'Success!',text: response.message,icon: 'success',confirmButtonText: 'Ok',position: 'top-end',showConfirmButton: false,timer: 3000})
              }
              else {
                  Swal.fire({title: 'Error!',text: response.message,icon: 'error',confirmButtonText: 'Ok',position: 'top-end',showConfirmButton: false,timer: 3000})
              }
        } catch(e){
          console.error("Error in login")
          console.log(e)
        }
        this.getUsers()
      },
    }
  }
</script>

<style>
  .b_card{
    background-color: white;
    /* box-shadow: rgb(136, 136, 136) 2px 5px 7px 2px; */
  }

  .bg_page {
    background: white;
    height: 100%;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding-bottom: 20px;
    /*position: fixed;*/
    /*background: rgb(2, 0, 36);*/
    /*background: linear-gradient(152deg, rgba(2, 0, 36, 1) 0%, rgba(15, 15, 126, 1) 49%, rgba(0, 212, 255, 1) 100%);*/
  }
  .logout:hover{
    background-color: #b82e2b;
  }
  .v_tag{
    overflow-y: scroll;
    max-height: 100px;
  }
  .link{
  color: blue;
  cursor: pointer;
}
</style>
